/** @format */

import React from 'react';
import {PRODUCT_TYPE_LABEL, OPERATOR_EXP_TEAM} from 'frontier-constants';

const DefaultUserContext = {
    handleUpdate: () => {},
    isAuthorized: () => {},
    current_user_name: '',
    current_user_id: 0,
    is_net_30: false,
    operator_type_id: OPERATOR_EXP_TEAM,
    is_guided_workflow: false,
    product_type_id: PRODUCT_TYPE_LABEL, // Responsible for interface changes
    permissions: []
};
export default React.createContext(DefaultUserContext);

export {DefaultUserContext};
